import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Container } from "reactstrap";
import "./styles/App.css";
import classes from "./components/Shop/Pc_Shop.module.css";
import { ImageMap } from "@qiuz/react-image-map";
import mapArea from "./components/Shop/mapArea";
import LoadRegion from "./components/Shop/LoadRegion";
import FindSigong from "./components/Shop/FindSigong";

const Shop = () => {
  const history = useHistory();
  const all_map = "/img/map/전지역.png";

  const [isName, setIsName] = useState("");
  const [isRegion, setIsRegion] = useState("");
  const [keyword, setKeyword] = useState("");
  const [mapUrl, setUrl] = useState(all_map);

  const onRegionClick = (e) => {
    const { name } = e.target.dataset;
    setIsRegion(name);
  };
  const sigongSearch = () => {
    setUrl(all_map);
    setIsName("");
    setIsRegion("");
  };
  const onKeyword = (e) => {
    const { value } = e.target;
    setKeyword(value);
  };
  const onMapClick = (area, index) => {
    console.log("area.url : ", area.url);
    setUrl(area.url);
    setIsName(area.name);
    setKeyword("");
  };

  return (
    <Container className={`px-5 ${classes.mgstyle}`}>
      <div className="indexTopTitle">시공지점 선택</div>

      <div>
        <div className="wrapDaeri row">
          <div className="col-5">
            <ImageMap
              className="usage-map"
              src={mapUrl}
              map={mapArea}
              onMapClick={onMapClick}
            />
          </div>

          <div className="col-7 pl-0 pr-0 mt-3">
            <div className="mapHwakText">
              지도에서 원하는 지역을 클릭하시거나 검색창에 직접 입력하시면
              원하시는 ABYS의 대리점을 확인할 수 있습니다.
            </div>
            <div className="row p-0 mt-5">
              <LoadRegion
                isName={isName}
                isRegion={isRegion}
                onRegionClick={onRegionClick}
              />
            </div>
            <div className="col-12 text-right pl-0 pr-0" onClick={sigongSearch}>
              <input
                type="text"
                className="col-7"
                style={{ border: "1px solid #C4C4C4", marginTop: "51px" }}
                value={keyword}
                onChange={onKeyword}
              />
              <span className={`${classes.custombtn} col-2`}>검색</span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-2" id="tSigongWrap">
        <FindSigong isName={isName} isRegion={isRegion} keyword={keyword} />
      </div>
      <div
        className="float-right font-weight-bold text-muted mt-5"
        onClick={() => history.push("/cart")}
      >
        뒤로가기
      </div>
    </Container>
  );
};

export default Shop;
